export class PageInfo {
    title: string;
    subTitle: string;
    icon: string;
}
